module.exports = __webpack_public_path__ + "static/media/hero-snap-one.1d871dcf.jpg";